import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { createOrganization, getOrganizationById, updateOrganization } from '../../../services/organizations';
import Input from '../../../components/Forms/Input';
import Select from '../../../components/Forms/Select';

const OrganizationForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id && id !== 'undefined'; // ensure id is valid
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { control, handleSubmit, reset, setValue } = useForm({
    defaultValues: {
      name: '',
      org_code: '',
      status: 'active',
      hierarchy_config: '',
    }
  });

  useEffect(() => {
    if (isEdit) {
      loadOrganization();
    }
  }, [id]);

  const loadOrganization = async () => {
    try {
      setLoading(true);
      const data = await getOrganizationById(id);
      reset(data);
      if (data.hierarchy_config) {
        setValue('hierarchy_config', JSON.stringify(data.hierarchy_config, null, 2));
      }
    } catch (err) {
      setError('Failed to load organization');
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    setError('');
    try {
      const payload = { ...data };
      if (payload.hierarchy_config) {
        payload.hierarchy_config = JSON.parse(payload.hierarchy_config);
      }
      if (isEdit) {
        await updateOrganization(id, payload);
      } else {
        await createOrganization(payload);
      }
      navigate('/dashboard/super-admin/organizations');
    } catch (err) {
      setError(err.response?.data?.error || 'Operation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>{isEdit ? 'Edit Organization' : 'Create Organization'}</h1>
      {error && <div className="error">{error}</div>}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input name="name" control={control} label="Organization Name" rules={{ required: 'Name required' }} />
        <Input name="org_code" control={control} label="Organization Code" rules={{ required: 'Code required' }} />
        <Select
          name="status"
          control={control}
          label="Status"
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
        />
        <Input
          name="hierarchy_config"
          control={control}
          label="Hierarchy Configuration (JSON)"
          placeholder='[{"level":1,"name":"Monthly Meeting","code":"MM"},{"level":2,"name":"Local Church","code":"LC"}]'
          rules={{ required: 'Hierarchy config required' }}
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </button>
        <button type="button" onClick={() => navigate('/dashboard/super-admin/organizations')}>Cancel</button>
      </form>
    </div>
  );
};

export default OrganizationForm;